import { gql } from '@apollo/client';
import { GRAPHQL_FRAGMENTS } from 'client/data/constants/graphql-fragments';
import { CAR_TYPES } from 'site-modules/shared/constants/upper-funnel/car-types';

export const COMPLEX_TYPE_RANKINGS_QUERIES = {
  [CAR_TYPES.EXOTIC]: gql`
    ${GRAPHQL_FRAGMENTS.rangeFields}
    ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
    query ($pageSize: Int, $isElectric: Boolean!, $rankRangeStart: Int, $rankRangeEnd: Int) {
      exotic_coupes: vehicleEditorialRankings(
        edmundsTypeCategory: "Coupe"
        subsegment: "Exotic"
        market: "Exotic coupes"
      ) {
        ...editorialSegmentFieldsFull
      }
      exotic_sport_coupes: vehicleEditorialRankings(
        edmundsTypeCategory: "Coupe"
        subsegment: "Sport"
        market: "Exotic coupes"
      ) {
        ...editorialSegmentFieldsFull
      }
      exotic_sedans: vehicleEditorialRankings(edmundsTypeCategory: "Sedan", subsegment: "Exotic") {
        ...editorialSegmentFieldsFull
      }
      exotic_convertibles: vehicleEditorialRankings(
        edmundsTypeCategory: "Convertible"
        subsegment: "Exotic"
        market: "Exotic convertibles"
      ) {
        ...editorialSegmentFieldsFull
      }
    }
  `,
  [CAR_TYPES.ECONOMY]: gql`
    ${GRAPHQL_FRAGMENTS.rangeFields}
    ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
    query ($pageSize: Int, $isElectric: Boolean!, $rankRangeStart: Int, $rankRangeEnd: Int) {
      subcompact_sedans: vehicleEditorialRankings(
        edmundsTypeCategory: "Sedan"
        subsegment: "X-Small"
        market: "Sedans"
      ) {
        ...editorialSegmentFieldsFull
      }
      compact_sedans: vehicleEditorialRankings(edmundsTypeCategory: "Sedan", subsegment: "Small", market: "Sedans") {
        ...editorialSegmentFieldsFull
      }
      subcompact_hatchbacks: vehicleEditorialRankings(
        edmundsTypeCategory: "Hatchback"
        subsegment: "X-Small"
        market: ""
      ) {
        ...editorialSegmentFieldsFull
      }
      compact_hatchbacks: vehicleEditorialRankings(edmundsTypeCategory: "Hatchback", subsegment: "Small", market: "") {
        ...editorialSegmentFieldsFull
      }
    }
  `,
  [CAR_TYPES.SUBCOMPACT]: gql`
    ${GRAPHQL_FRAGMENTS.rangeFields}
    ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
    query ($pageSize: Int, $isElectric: Boolean!, $rankRangeStart: Int, $rankRangeEnd: Int) {
      subcompact_sedans: vehicleEditorialRankings(
        edmundsTypeCategory: "Sedan"
        subsegment: "X-Small"
        market: "Sedans"
      ) {
        ...editorialSegmentFieldsFull
      }
      subcompact_hatchbacks: vehicleEditorialRankings(
        edmundsTypeCategory: "Hatchback"
        subsegment: "X-Small"
        market: ""
      ) {
        ...editorialSegmentFieldsFull
      }
      subcompact_luxury_crossovers: vehicleEditorialRankings(
        edmundsTypeCategory: "SUV"
        subsegment: "X-Small"
        market: "Luxury SUVs"
      ) {
        ...editorialSegmentFieldsFull
      }
      subcompact_crossovers: vehicleEditorialRankings(
        edmundsTypeCategory: "SUV"
        subsegment: "X-Small"
        market: "SUVs"
      ) {
        ...editorialSegmentFieldsFull
      }
    }
  `,
  [CAR_TYPES.MIDSIZE]: gql`
    ${GRAPHQL_FRAGMENTS.rangeFields}
    ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
    query ($pageSize: Int, $isElectric: Boolean!, $rankRangeStart: Int, $rankRangeEnd: Int) {
      midsize_sedans: vehicleEditorialRankings(edmundsTypeCategory: "Sedan", subsegment: "Midsize", market: "Sedans") {
        ...editorialSegmentFieldsFull
      }
      midsize_luxury_sedans: vehicleEditorialRankings(
        edmundsTypeCategory: "Sedan"
        subsegment: "Midsize"
        market: "Luxury sedans"
      ) {
        ...editorialSegmentFieldsFull
      }
      midsize_wagon: vehicleEditorialRankings(edmundsTypeCategory: "Wagon", subsegment: "Midsize", market: "") {
        ...editorialSegmentFieldsFull
      }
      midsize_crossovers: vehicleEditorialRankings(edmundsTypeCategory: "SUV", subsegment: "Midsize", market: "SUVs") {
        ...editorialSegmentFieldsFull
      }
      midsize_luxury_crossovers: vehicleEditorialRankings(
        edmundsTypeCategory: "SUV"
        subsegment: "Midsize"
        market: "Luxury SUVs"
      ) {
        ...editorialSegmentFieldsFull
      }
    }
  `,
  [CAR_TYPES.MUSCLE]: gql`
    ${GRAPHQL_FRAGMENTS.rangeFields}
    ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
    query ($pageSize: Int, $isElectric: Boolean!, $rankRangeStart: Int, $rankRangeEnd: Int) {
      muscle_coupes: vehicleEditorialRankings(edmundsTypeCategory: "Coupe", subsegment: "Muscle car") {
        ...editorialSegmentFieldsFull
      }
    }
  `,
  [CAR_TYPES.CROSSOVER]: gql`
    ${GRAPHQL_FRAGMENTS.rangeFields}
    ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
    query ($pageSize: Int, $isElectric: Boolean!, $rankRangeStart: Int, $rankRangeEnd: Int) {
      x_small_suv: vehicleEditorialRankings(edmundsTypeCategory: "SUV", subsegment: "X-Small") {
        ...editorialSegmentFieldsFull
      }
      small_suv: vehicleEditorialRankings(edmundsTypeCategory: "SUV", subsegment: "Small") {
        ...editorialSegmentFieldsFull
      }
      midsize_suv: vehicleEditorialRankings(edmundsTypeCategory: "SUV", subsegment: "Midsize") {
        ...editorialSegmentFieldsFull
      }
      midsize_3row_suv: vehicleEditorialRankings(edmundsTypeCategory: "SUV", subsegment: "Midsize 3-row") {
        ...editorialSegmentFieldsFull
      }
    }
  `,
  [CAR_TYPES.SPORTS_CAR]: gql`
    ${GRAPHQL_FRAGMENTS.rangeFields}
    ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
    query ($pageSize: Int, $isElectric: Boolean!, $rankRangeStart: Int, $rankRangeEnd: Int) {
      standard_coupes: vehicleEditorialRankings(
        edmundsTypeCategory: "Coupe"
        subsegment: "Standard"
        market: "Coupes"
      ) {
        ...editorialSegmentFieldsFull
      }
      luxury_sport_coupes: vehicleEditorialRankings(
        edmundsTypeCategory: "Coupe"
        subsegment: "Sport"
        market: "Luxury coupes"
      ) {
        ...editorialSegmentFieldsFull
      }
      exotic_sport_coupes: vehicleEditorialRankings(
        edmundsTypeCategory: "Coupe"
        subsegment: "Sport"
        market: "Exotic coupes"
      ) {
        ...editorialSegmentFieldsFull
      }
    }
  `,
  [CAR_TYPES.COMPACT]: gql`
    ${GRAPHQL_FRAGMENTS.rangeFields}
    ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
    query ($pageSize: Int, $isElectric: Boolean!, $rankRangeStart: Int, $rankRangeEnd: Int) {
      compact_sedans: vehicleEditorialRankings(edmundsTypeCategory: "Sedan", subsegment: "Small", market: "Sedans") {
        ...editorialSegmentFieldsFull
      }
      compact_hatchbacks: vehicleEditorialRankings(
        edmundsTypeCategory: "Hatchback"
        subsegment: "Small"
        market: "Performance hatchbacks"
      ) {
        ...editorialSegmentFieldsFull
      }
      compact_wagons: vehicleEditorialRankings(edmundsTypeCategory: "Wagon", subsegment: "Small", market: "") {
        ...editorialSegmentFieldsFull
      }
      compact_crossovers: vehicleEditorialRankings(edmundsTypeCategory: "SUV", subsegment: "Small", market: "SUVs") {
        ...editorialSegmentFieldsFull
      }
    }
  `,
  [CAR_TYPES.ELECTRICAWD]: gql`
    ${GRAPHQL_FRAGMENTS.rangeFields}
    ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
    query ($rankRangeStart: Int, $rankRangeEnd: Int, $pageSize: Int, $isElectric: Boolean!) {
      awdElectricCars: vehicleEditorialRankings(
        edmundsTypeCategory: "Electric"
        subsegment: "All-wheel-drive electric cars"
      ) {
        ...editorialSegmentFieldsFull
      }
      awdElectricSUVs: vehicleEditorialRankings(
        edmundsTypeCategory: "Electric"
        subsegment: "All-wheel-drive electric SUVs"
      ) {
        ...editorialSegmentFieldsFull
      }
      electricCars: vehicleEditorialRankings(edmundsTypeCategory: "Electric", subsegment: "Electric cars") {
        ...editorialSegmentFieldsFull
      }
      electricSUVs: vehicleEditorialRankings(edmundsTypeCategory: "Electric", subsegment: "Electric SUVs") {
        ...editorialSegmentFieldsFull
      }
      awdElectricTrucks: vehicleEditorialRankings(
        edmundsTypeCategory: "Electric"
        subsegment: "All-wheel-drive electric trucks"
      ) {
        ...editorialSegmentFieldsFull
      }
    }
  `,
  [CAR_TYPES.ELECTRICSUVS]: gql`
    ${GRAPHQL_FRAGMENTS.rangeFields}
    ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
    query ($rankRangeStart: Int, $rankRangeEnd: Int, $pageSize: Int, $isElectric: Boolean!) {
      electricSUVs: vehicleEditorialRankings(
        edmundsTypeCategory: "Electric"
        market: "Electric"
        subsegment: "Electric SUVs"
      ) {
        ...editorialSegmentFieldsFull
      }
      allWheelDriveElectricSUVs: vehicleEditorialRankings(
        edmundsTypeCategory: "Electric"
        subsegment: "All-wheel-drive electric SUVs"
      ) {
        ...editorialSegmentFieldsFull
      }
      luxuryElectricSUVs: vehicleEditorialRankings(
        edmundsTypeCategory: "Electric"
        market: "Luxury electric"
        subsegment: "Electric SUVs"
      ) {
        ...editorialSegmentFieldsFull
      }
      performanceElectricSUVs: vehicleEditorialRankings(
        edmundsTypeCategory: "Electric"
        market: "Performance electric"
        subsegment: "Electric SUVs"
      ) {
        ...editorialSegmentFieldsFull
      }
    }
  `,
  [CAR_TYPES.HYBRIDSUVS]: gql`
    ${GRAPHQL_FRAGMENTS.rangeFields}
    ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
    query ($rankRangeStart: Int, $rankRangeEnd: Int, $pageSize: Int, $isElectric: Boolean!) {
      hybridSUVs: vehicleEditorialRankings(edmundsTypeCategory: "Hybrid", subsegment: "Hybrid SUVs") {
        ...editorialSegmentFieldsFull
      }
      pluginHybridSUVs: vehicleEditorialRankings(edmundsTypeCategory: "Hybrid", subsegment: "Plug-in hybrid SUVs") {
        ...editorialSegmentFieldsFull
      }
    }
  `,
  [CAR_TYPES.LARGESUVS]: gql`
    ${GRAPHQL_FRAGMENTS.rangeFields}
    ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
    query ($rankRangeStart: Int, $rankRangeEnd: Int, $pageSize: Int, $isElectric: Boolean!) {
      largeSUVs: vehicleEditorialRankings(edmundsTypeCategory: "SUV", subsegment: "Large") {
        ...editorialSegmentFieldsFull
      }
    }
  `,
  [CAR_TYPES.SMALLSUVS]: gql`
    ${GRAPHQL_FRAGMENTS.rangeFields}
    ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
    query ($rankRangeStart: Int, $rankRangeEnd: Int, $pageSize: Int, $isElectric: Boolean!) {
      xSmallSUVs: vehicleEditorialRankings(edmundsTypeCategory: "SUV", subsegment: "X-Small") {
        ...editorialSegmentFieldsFull
      }
      smallSUVs: vehicleEditorialRankings(edmundsTypeCategory: "SUV", subsegment: "Small") {
        ...editorialSegmentFieldsFull
      }
      small3RowSUVs: vehicleEditorialRankings(edmundsTypeCategory: "SUV", subsegment: "Small 3-row") {
        ...editorialSegmentFieldsFull
      }
    }
  `,
  [CAR_TYPES.MIDSIZESUVS]: gql`
    ${GRAPHQL_FRAGMENTS.rangeFields}
    ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
    query ($rankRangeStart: Int, $rankRangeEnd: Int, $pageSize: Int, $isElectric: Boolean!) {
      midsizeSUVs: vehicleEditorialRankings(edmundsTypeCategory: "SUV", subsegment: "Midsize") {
        ...editorialSegmentFieldsFull
      }
      midsize3RowSUVs: vehicleEditorialRankings(edmundsTypeCategory: "SUV", subsegment: "Midsize 3-row") {
        ...editorialSegmentFieldsFull
      }
    }
  `,
  [CAR_TYPES.LUXURYSUVS]: gql`
    ${GRAPHQL_FRAGMENTS.rangeFields}
    ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
    query ($rankRangeStart: Int, $rankRangeEnd: Int, $pageSize: Int, $isElectric: Boolean!) {
      luxuryAllWheelDriveElectricSUVs: vehicleEditorialRankings(
        edmundsTypeCategory: "Electric"
        market: "Luxury electric"
        subsegment: "All-wheel-drive electric SUVs"
      ) {
        ...editorialSegmentFieldsFull
      }
      performanceElectricSUVs: vehicleEditorialRankings(
        edmundsTypeCategory: "Electric"
        market: "Performance electric"
        subsegment: "Electric SUVs"
      ) {
        ...editorialSegmentFieldsFull
      }
      LuxuryPlugInHybridSUVs: vehicleEditorialRankings(
        edmundsTypeCategory: "Hybrid"
        market: "Luxury hybrids"
        subsegment: "Plug-in hybrid SUVs"
      ) {
        ...editorialSegmentFieldsFull
      }
      luxurySUVs: vehicleEditorialRankings(edmundsTypeCategory: "SUV", market: "Luxury SUVs") {
        ...editorialSegmentFieldsFull
      }
      performanceSUVs: vehicleEditorialRankings(edmundsTypeCategory: "SUV", market: "Performance SUVs") {
        ...editorialSegmentFieldsFull
      }
    }
  `,
  [CAR_TYPES.LUXURY]: gql`
    ${GRAPHQL_FRAGMENTS.rangeFields}
    ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
    query ($rankRangeStart: Int, $rankRangeEnd: Int, $pageSize: Int, $isElectric: Boolean!) {
      luxurySedans: vehicleEditorialRankings(edmundsTypeCategory: "Sedan", market: "Luxury sedans") {
        ...editorialSegmentFieldsFull
      }
      luxuryCoupes: vehicleEditorialRankings(edmundsTypeCategory: "Coupe", market: "Luxury coupes") {
        ...editorialSegmentFieldsFull
      }
      luxurySUVs: vehicleEditorialRankings(edmundsTypeCategory: "SUV", market: "Luxury SUVs") {
        ...editorialSegmentFieldsFull
      }
      luxuryHybrids: vehicleEditorialRankings(edmundsTypeCategory: "Hybrid", market: "Luxury hybrids") {
        ...editorialSegmentFieldsFull
      }
    }
  `,
  [CAR_TYPES.THREEROWSUVS]: gql`
    ${GRAPHQL_FRAGMENTS.rangeFields}
    ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
    query ($rankRangeStart: Int, $rankRangeEnd: Int, $pageSize: Int, $isElectric: Boolean!) {
      small3RowSUVs: vehicleEditorialRankings(edmundsTypeCategory: "SUV", subsegment: "Small 3-row") {
        ...editorialSegmentFieldsFull
      }
      midsize3RowSUVs: vehicleEditorialRankings(edmundsTypeCategory: "SUV", subsegment: "Midsize 3-row") {
        ...editorialSegmentFieldsFull
      }
      largeSUVs: vehicleEditorialRankings(edmundsTypeCategory: "SUV", subsegment: "Large") {
        ...editorialSegmentFieldsFull
      }
    }
  `,
};

export const SEPARATED_TYPE_RANKINGS_QUERIES = {
  [CAR_TYPES.LUXURY]: gql`
    ${GRAPHQL_FRAGMENTS.rangeFields}
    ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
    query ($rankRangeStart: Int, $rankRangeEnd: Int, $pageSize: Int, $isElectric: Boolean!) {
      luxuryConvertibles: vehicleEditorialRankings(edmundsTypeCategory: "Convertible", market: "Luxury convertibles") {
        ...editorialSegmentFieldsFull
      }
      superLuxuryElectric: vehicleEditorialRankings(edmundsTypeCategory: "Electric", market: "Super Luxury electric") {
        ...editorialSegmentFieldsFull
      }
      luxuryElectric: vehicleEditorialRankings(edmundsTypeCategory: "Electric", market: "Luxury electric") {
        ...editorialSegmentFieldsFull
      }
    }
  `,
};
